import React, { FC, ReactElement } from 'react'

import { Page } from '../../components'
import { ConnectedLeaveOfAbsenceEdit } from '../../connectors'

const AbsenceEditPage: FC = (): ReactElement => (
    <Page className="absence-edit-page">
        <ConnectedLeaveOfAbsenceEdit />
    </Page>
)

export default AbsenceEditPage
